(function ($) {

    if ($('.grid-masonry').length > 0 ) {
        addScript(scripts, 'masonry', () => {

            $('.grid-masonry').masonry({
                itemSelector: ".grid-item",
                columnWidth: ".grid-item",
                percentPosition: true
            });

            $('.grid-masonry').imagesLoaded(function () {
                $('.grid-masonry').css('visibility', 'visible');
            });

        if ($(".fancybox-thumb")[0]) {
            $(".fancybox-thumb").fancybox({
                arrows: true,
                buttons: [
                    "close"
                ],
                clickSlide: false
                });
        }
        });
    }

})(jQuery);